// import BTImage from "images/devices/bt.png" // based on files within /src at compile time
import BTImage2 from "images/devices/bt_router_2.jpg"

export const BT = {
  id: "BT_ROUTER",
  img: BTImage2, // converts the location of bt.png in /src/images/devices to wherever webpack puts it
  // img: "../../images/devices/bt.png", // based on files within /public at compile time -- ie, not converted
  name: "BT Smart Hub",
  rating: 5,
  availableColors: ["black"],
  details: {
    title1: "Intelligent design",
    text1: "7 antenna are uniquely positioned to maximise to Wi-Fi performance",
    title2: "Best Wi-Fi tech",
    text2:
      "The latest Wi-Fi technology ensures more devices can get a superfast connection at the same time",
    title3: "Smart channel selection",
    text3:
      "All your devices auto connect to the fastest Wi-Fi channel and frequency available",
    title4: "Smart Scan",
    text4:
      "Continually scans to see how well your hub and network connection is performing and reboots itself if there's a problem"
  }
}
